export const gettrackmeEventCategory = (text: string): string => {
    return encodeURI(`${text} [${document.documentElement.lang}]`);
};

export const gettrackmeEventObject = (text: string): string => {
    return encodeURI(`${text}`);
};
